export default __webpack_public_path__ + "static/media/binance.aa00fabf.svg";